var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebtScheduleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 222,
    viewBox: "0 0 166 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.942 219.654H15.3735C7.94154 219.654 1.90039 213.613 1.90039 206.181V45.5036C1.90039 38.0717 7.94154 32.0305 15.3735 32.0305H120.942C128.373 32.0305 134.415 38.0717 134.415 45.5036V206.181C134.415 213.613 128.373 219.654 120.942 219.654Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.942 219.654H15.3735C7.94154 219.654 1.90039 213.613 1.90039 206.181V45.5036C1.90039 38.0717 7.94154 32.0305 15.3735 32.0305H120.942C128.373 32.0305 134.415 38.0717 134.415 45.5036V206.181C134.415 213.613 128.373 219.654 120.942 219.654Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.761 204.79H30.2367C22.8048 204.79 16.7637 198.749 16.7637 191.317V30.683C16.7637 23.2511 22.8048 17.21 30.2367 17.21H135.805C143.237 17.21 149.278 23.2511 149.278 30.683V191.36C149.234 198.792 143.237 204.79 135.761 204.79Z",
    fill: "#FFCF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.761 204.79H30.2367C22.8048 204.79 16.7637 198.749 16.7637 191.317V30.683C16.7637 23.2511 22.8048 17.21 30.2367 17.21H135.805C143.237 17.21 149.278 23.2511 149.278 30.683V191.36C149.234 198.792 143.237 204.79 135.761 204.79Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.626 189.97H45.058C37.6261 189.97 31.585 183.928 31.585 176.497V15.8193C31.585 8.38734 37.6261 2.34619 45.058 2.34619H150.626C158.058 2.34619 164.099 8.38734 164.099 15.8193V176.497C164.099 183.928 158.058 189.97 150.626 189.97Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.626 189.97H45.058C37.6261 189.97 31.585 183.928 31.585 176.497V15.8193C31.585 8.38734 37.6261 2.34619 45.058 2.34619H150.626C158.058 2.34619 164.099 8.38734 164.099 15.8193V176.497C164.099 183.928 158.058 189.97 150.626 189.97Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.707 124.473H140.978",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.707 143.161H140.978",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.707 161.85H140.978",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.117 71.5371C121.03 70.5375 120.683 69.1467 120.118 67.4082C119.509 65.6698 118.683 64.1921 117.553 62.9751C116.423 61.7582 114.772 60.4544 112.555 59.1071C110.339 57.7598 107.688 56.6732 104.558 55.8475L101.994 55.1955V40.2013C103.168 40.549 104.211 41.2009 105.123 42.2875C106.471 43.8521 107.166 45.7644 107.209 47.9809H119.118C118.77 42.5048 116.901 38.289 113.511 35.3771C110.469 32.7694 106.601 31.1178 101.994 30.3355V23.6425H100.256H95.301H93.6494V30.2921C88.8687 30.9005 84.8268 32.5521 81.4368 35.3336C77.6991 38.4194 75.8302 42.6786 75.8302 48.0678C75.8302 50.7625 76.2648 53.0659 77.1775 55.0217C78.0902 56.9775 79.3941 58.5855 81.176 59.8025C82.9579 61.0194 84.6529 62.019 86.3914 62.7578C88.0864 63.4967 90.1725 64.1486 92.6498 64.7571C93.041 64.844 93.3887 64.9309 93.6929 65.0178V82.6198C91.7371 81.9678 90.1291 80.9248 88.7818 79.4036C87.0868 77.4913 86.3044 75.014 86.3479 71.9717H74.4395C75.6129 84.3582 82.0452 91.2686 93.6929 92.7028V100.004H95.3444H100.299H102.038V92.7028C104.558 92.3986 106.818 91.8771 108.904 91.0948C111.469 90.0951 113.468 88.9651 114.946 87.6613C116.423 86.3575 117.684 84.8798 118.683 83.3151C119.683 81.7071 120.378 80.2728 120.726 78.969C121.074 77.6651 121.291 76.4482 121.291 75.4051C121.248 73.8405 121.204 72.5802 121.117 71.5371ZM89.4771 51.1536C88.3471 50.154 87.7387 48.7198 87.7387 46.8944C87.7387 44.6778 88.4775 42.9394 89.9552 41.7225C91.0418 40.8532 92.2587 40.2882 93.6494 40.0709V53.1528C91.8241 52.6313 90.3898 51.9359 89.4771 51.1536ZM106.601 80.6205C105.21 81.6636 103.689 82.4025 101.994 82.7936V67.4517C104.471 68.234 106.297 69.0598 107.34 69.9725C108.644 71.1025 109.296 72.7105 109.296 74.8401C109.339 77.274 108.426 79.2298 106.601 80.6205Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtScheduleIcon);
export default __webpack_public_path__ + "static/media/DebtScheduleIcon.0c308eff90712e5d6de88dc50b47ae0f.svg";
export { ForwardRef as ReactComponent };